// extracted by mini-css-extract-plugin
export default {"wrapper":"superUserAdmin_wrapper__gFy6X"};